import { render, staticRenderFns } from "./SwEventConfig.vue?vue&type=template&id=01d053fb&scoped=true"
import script from "./SwEventConfig.vue?vue&type=script&lang=js"
export * from "./SwEventConfig.vue?vue&type=script&lang=js"
import style0 from "./SwEventConfig.vue?vue&type=style&index=0&id=01d053fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d053fb",
  null
  
)

export default component.exports